export const common = {
  nav: {
    home: 'Accueil',
    about: 'À Propos',
    products: 'Produits',
    affiliate: 'Devenir Affilié',
    contact: 'Contact',
    cart: 'Panier',
  },
  hero: {
    title1: 'Découvrez la Sélection Premium',
    title2: 'de Fruits Secs NOZA',
    tagline: 'Pure Selected',
    cta: 'Explorer Nos Produits',
  },
  about: {
    label: 'Notre Histoire',
    title1: "L'Excellence",
    title2: 'Algérienne',
    description: "NOZA est née d'une passion pour les fruits secs d'exception et d'un engagement envers la qualité. Basée en Algérie, notre marque sélectionne méticuleusement chaque pistache, noix de cajou et amande pour vous offrir une expérience gustative incomparable. Nos méthodes de torréfaction artisanale préservent les saveurs naturelles et les bienfaits nutritionnels. Chaque fruit sec est sélectionné à la main par nos experts, garantissant une qualité constante et une fraîcheur optimale. Notre engagement envers l'excellence se reflète dans chaque paquet NOZA.",
    card1Title: '100%',
    card1Subtitle: 'Naturel',
    card1Text: 'Sans additifs artificiels',
    card1Tagline: 'La pureté dans chaque bouchée',
    card2Title: '15+',
    card2Subtitle: "Années d'expérience",
    card2Text: 'Dans la sélection premium',
    cta: 'Découvrir Notre Processus',
  },
  products: {
    title: 'Nos Produits Signature',
    subtitle: 'Sélection artisanale de fruits secs premium',
    viewDetails: 'Voir Détails',
    delivery: 'Livraison disponible en Algérie',
  },
  cart: {
    title: 'Mon Panier',
    empty: 'Votre panier est vide',
    goShopping: 'Continuer mes achats',
    orderSummary: 'Récapitulatif de la commande',
    total: 'Total',
    confirm: 'Confirmer la Commande',
    remove: 'Retirer',
    subtotal: 'Sous-total',
    item: 'Article',
    items: 'Articles',
    shippingInfo: 'Informations de livraison',
    paymentMethod: 'Mode de paiement',
    cod: 'Paiement à la livraison (COD)',
  },
  orderType: {
    label: 'Type de commande',
    particulier: 'Particulier',
    magasin: 'Magasin',
    particulierDesc: 'Pour les particuliers : commandez vos sachets en petites quantités.',
    magasinDesc: 'Pour les magasins : commandez une boîte contenant 10 produits NOZA. Sélectionnez le nombre de boîtes souhaitées.',
    required: 'Veuillez choisir un type de commande',
    boxInfo: '1 boîte = 10 produits',
    boxCount: 'Nombre de boîtes',
    totalProducts: 'Vous recevrez {boxes} boîtes × 10 produits = {total} produits au total',
    box: 'boîte',
    boxes: 'boîtes',
    pack: 'sachet',
    packs: 'sachets',
  },
  toast: {
    addedToCart: '{product} ajouté au panier !',
    orderConfirmed: 'Commande confirmée ! Vous recevrez un appel ou email de confirmation bientôt.',
    success: 'Succès',
    error: 'Erreur',
  },
  footer: {
    newsletter: 'Restez Informé',
    newsletterDesc: 'Recevez nos offres exclusives et nouveautés',
    emailPlaceholder: 'Votre adresse email',
    subscribe: "S'abonner",
    navigation: 'Navigation',
    contact: 'Contact',
    address: 'Adresse',
    addressLine1: 'Coopératif les platanes , Birkhadem',
    addressLine2: 'Alger, Algerie',
    copyright: '© 2025 NOZA Nuts. Tous droits réservés.',
    privacy: 'Politique de Confidentialité',
    terms: "Conditions d'Utilisation",
  },
  common: {
    learnMore: 'En Savoir Plus',
    orderNow: 'Commander Maintenant',
    addToCart: 'Ajouter au Panier',
    submit: 'Soumettre',
    close: 'Fermer',
  },
};